import * as React from 'react';
import { Draggable } from 'react-managed-draggable';
export class ColumnSeparatorRenderer extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            deltaY: null
        };
        this.handleDragStart = (event, dragInformation) => {
            const deltaY = this.props.clamp(this.props.index, dragInformation.current.y - dragInformation.start.y);
            this.setState({ deltaY });
        };
        this.handleDragMove = (event, dragInformation) => {
            const deltaY = this.props.clamp(this.props.index, dragInformation.current.y - dragInformation.start.y);
            this.setState({ deltaY });
        };
        this.handleDragEnd = (event, dragInformation) => {
            this.setState({ deltaY: null });
            const deltaY = this.props.clamp(this.props.index, dragInformation.current.y - dragInformation.start.y);
            if (deltaY !== null) {
                this.props.onMove(this.props.index, deltaY);
            }
        };
    }
    render() {
        let top = 0;
        if (this.state.deltaY !== null) {
            top = this.state.deltaY;
        }
        return React.createElement(Draggable, { onDragStart: this.handleDragStart, onDragMove: this.handleDragMove, onDragEnd: this.handleDragEnd },
            React.createElement(this.props.floatyRenderers.columnSeparatorHandleRenderer, { offset: top }));
    }
}
//# sourceMappingURL=column-separator-renderer.js.map